export const CITY_BOUND_SW = {lat: 49.99, lng: 19.81};
export const CITY_BOUND_NE = {lat: 50.12, lng: 20.14};
export const MAP_CENTER = {lat: 50.08, lng: 19.96};



// WEBPACK FOOTER //
// ./src/constants/places.js